import { render, staticRenderFns } from "./SVG-PlaneClouds.vue?vue&type=template&id=63dfbce4&scoped=true&"
import script from "./SVG-PlaneClouds.vue?vue&type=script&lang=js&"
export * from "./SVG-PlaneClouds.vue?vue&type=script&lang=js&"
import style0 from "./SVG-PlaneClouds.vue?vue&type=style&index=0&id=63dfbce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfbce4",
  null
  
)

export default component.exports